import axios from "axios";
import { Message, Loading } from "element-ui";
import router from "@/router/index.js";
import store from "@/store";
import Qs from "qs";
import {isEncrypt} from "@/plugins/keyConfig.js";
import smSecutityUtil from "@/utils/smSecutityUtil.js"
// import md5 from 'js-md5';
let loading;
axios.defaults.withCredentials = true;
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // baseURL: "http://10.1.94.97:8085/rczp/serv", // url = base url + request url
    // baseURL: "http://10.1.94.52:9003/rczp/serv", // url = base url + request url
    // baseURL: "http://218.22.167.228:48080/rczp/serv", // url = base url + request url
    // baseURL: "http://10.1.94.212:8080/rczp/serv", // url = base url + request url
    // baseURL: "http://10.1.52.113:6699/rczp/serv", // url = base url + request url
    // baseURL: "/serv", // url = base url + request url
    baseURL: "/rczp/serv",
    timeout: 60000, // request timeout
    withCredentials: true,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
});
service.interceptors.request.use(
    (config) => {
        loading = Loading.service();
        // console.log(config);
        // let temp = '';
        // let sig = '';
        // let arr = new Array;
        // for (var objj in config.data) {
        //     temp = objj + '=' + config.data[objj];
        //     arr.push(temp);
        // };
        let uuid = sessionStorage.getItem("__usersession_uuid");
        if (uuid) {
            config.headers = {...config.headers, 'usersession_uuid': uuid}
            // config.params = {
            //     __usersession_uuid: uuid,
            // };
            console.log(config);
        }
        // for (var obj in config.params) {
        //     temp = obj + '=' + config.params[obj]
        //     arr.push(temp)
        // }
        // arr.sort()
        // for (var index in arr) {
        //     sig += arr[index];
        // }
        // console.log('sig', sig)
        // config.data = {...config.data, signature:md5(sig)}
        // console.log('config.data', config.data)
        if (config.headers["Content-Type"].indexOf("multipart") == -1) {
            console.log(config)
            config.data = Qs.stringify(config.data, {
                arrayFormat: "repeat",
            });
            console.log(config)
            if (isEncrypt) {
                config.transformRequest = (res) => {
                    return res
                };
                //对入参进行sm2加密
                config.data = smSecutityUtil.sm2encrypt(config.data);
                console.log('config.data', config.data)
                //对入参进行sm3签名
                var signature = smSecutityUtil.sm3sign(config.data);
                config.data = encodeURIComponent(config.data);
                config.headers = {...config.headers, 'signature': signature};
            }
        }

        return config;
    },
    (error) => {
        console.log(error); // for debug
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        console.log('response>>>', response);
        loading.close();
        const res = response;
        if (res.status !== 200) {
            Message({
                message: res.statusText || "Error",
                type: "error",
                duration: 5 * 1000,
            });
            return Promise.reject(new Error(res.statusText || "Error"));
        } else {
            if (isEncrypt && typeof res.data === 'string') {
                var handleData = res.data.replaceAll("\r\n", "");
                handleData = handleData.replaceAll("\n", "");
                let splits = getReturn(handleData);
                console.log('splits', splits)
                if (splits.length == 0) {
                    return Promise.reject("返回内容为空，请联系管理员或稍后再试！");
                } else {
                    let signature = splits[1];
                    let map = splits[3];
                    let verifySignatureResult = false;
                    if (!signature || !map) {
                        Promise.reject("电子签名或返回体为空，请联系管理员或稍后再试！");
                    } else {
                        // 验签
                        try {
                            verifySignatureResult = smSecutityUtil.verifySign(map,
                                signature);
                        } catch (e) {
                            return Promise.reject('电子签名验证失败，接收到的响应无效');
                        }
                        console.log('verifySignatureResult', verifySignatureResult)
                        if (!verifySignatureResult) {
                            return Promise.reject('电子签名验证失败，接收到的响应无效');
                        }
                        const sm4decryptData = smSecutityUtil.sm4decrypt(
                            map);
                                console.log('sm4decryptData', sm4decryptData)
                        res.data = JSON.parse(sm4decryptData);
                    }
                }
            }
            if (!res.data.gs_error) {
                return res.data;
            } else {
                let error = JSON.parse(res.data.gs_error);
                if (error.msg == "用户丢失") {
                    router.push("/home");
                    store.commit("openLogin");
                }
                Message({
                    message: error.msg,
                    type: "error",
                    duration: 5 * 1000,
                    showClose: true,
                });
                return Promise.reject(error.msg);
            }
        }
    },
    (error) => {
        loading.close();
        console.log(error);
        Message({
            message: error.message,
            type: "error",
            duration: 5 * 1000,
        });
        return Promise.reject(error);
    }
);

function getReturn(param) {
    var para = [];
	var paraIndex = param.indexOf("_");
	if (paraIndex > -1) {
		para = param.split("_")
	}
	return para;
}
export default service;
